<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/shipingBill' }">返回上一级</el-breadcrumb-item>
      <el-breadcrumb-item>货位统计</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="imgBox">
      <img src="@/assets/images/cabin.jpg" class="tupian" />
    </div>
    <div class="bottom">
      <div v-for="(item,index) in contentList" :key="index" class="allBox">
        <div class="button">
          <span>{{item.cargoHold}}</span>
          <el-button @click="xiangqing(item.cargoHold)" type="primary">详情</el-button>
        </div>
        <div class="xiangqing">
          <div v-for="(itemFloor,index) in item.floorList" :key="index" v-show="item.floorList.length!=0">
            <span class="title">{{itemFloor.layer}}</span>
            <div v-if="itemFloor.list.length!=0">
              <div class="content" v-for="(itemList,index) in itemFloor.list" :key="index">
                <span class="name">{{itemList.customerName}}</span><span class="number">{{itemList.number}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getShipGoodsLocation } from '@/api/shipping'
export default {
  data () {
    return {
      contentList: []
    }
  },
  created () {
    getShipGoodsLocation({ shipDateId: this.$route.query.shipDateId }).then(res => {
      console.log(res)
      this.contentList = res
    })
      .catch(error => {
        this.$message.error(error.message)
      })
  },
  methods: {
    xiangqing (val) {
      this.$router.push({
        path: '/goodsDetail',
        query: {
          cargoHold: val,
          shipDateId: this.$route.query.shipDateId,
          shipName: this.$route.query.shipName,
          shipDateNo: this.$route.query.shipDateNo
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.imgBox {
  width: 100%;
  margin-top: 15px;
  .tupian {
    width: 100%;
  }
}
.bottom {
  display: flex;
  // justify-content: space-around;
  margin-top: 15px;
  overflow-x: auto;
  .allBox {
    margin-left: 15px;
  }
  .button {
    width: 250px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;
  }
  .xiangqing {
    width: 250px;
    border: 1px solid black;
    border-radius: 5px;
    min-height: 200px;
    .title {
      font-weight: 600;
      margin: 5px;
    }
    .content {
      margin: 5px;
    }
    .number {
      color: red;
      margin-left: 10px;
    }
    .name {
      font-size: 14px;
      margin-left: 5px;
    }
  }
}
</style>
